import { render, staticRenderFns } from "./SchoolHeaderModule.vue?vue&type=template&id=1b3a9f6f&scoped=true"
import script from "./SchoolHeaderModule.vue?vue&type=script&lang=js"
export * from "./SchoolHeaderModule.vue?vue&type=script&lang=js"
import style0 from "./SchoolHeaderModule.vue?vue&type=style&index=0&id=1b3a9f6f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b3a9f6f",
  null
  
)

export default component.exports